import React, { useDebugValue, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, Input, Label, FormGroup, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { Translate, byteSize, TextFormat, log } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import {
  getEntity,
  getEntityProfileDetails,
  updateEntityUserType,
  getUserMentorMenteeCount,
} from 'app/entities/user-profile/user-profile.reducer';
import { getEntityMenteeQuestions } from 'app/entities/question/question.reducer';
import { MenteeQuesions } from './MenteeQuestions';
import { getEntityMenteeTopic } from 'app/entities/mentee-topic/mentee-topic.reducer';
import { MentorTopicSlice, getEntityMentorTopic } from 'app/entities/mentor-topic/mentor-topic.reducer';
import Tabs from './Tabs';
import Connections from './Connections';
import { Country, State } from 'country-state-city';
import { getEntityTotalPoints } from 'app/entities/point-allocation/point-allocation.reducer';
import TotalPoints from './TotalPoints';
import Meetings from './Meetings';
import { getStateByCode, getStatesOfCountry } from 'country-state-city/lib/state';
import countriesList from 'countries-list';
import InspirationPage from './Inspiration';
import HousingPage from './Housing';
import GoodGovernancePage from './GoodGovernance';
import ManagePoints from './ManagePoints';
import Interviews from './Interview';
import Introvideo from './Intro-video';
import { AGE_TEXT_QUEST } from 'app/config/constants';
import ProfileHeader from './user-profile/profile-header';
import ProfileBasicInfo from './user-profile/basic-info';
import ProfileAddress from './user-profile/profile-address';
import ProfileTopics from './user-profile/profile-topics';
import ProfileQuestions from './user-profile/profile-questions';
import ProfileStats from './user-profile/profile-stats';

interface StateType {
  tab: string;
  // Define other properties as needed
}

export const UserProfileDetail = props => {
  const dispatch = useAppDispatch();
  const { id } = useParams<'id'>();
  const [isMentee, setIsMentee] = useState(false);
  const [profileType, setProfileType] = useState('Mentor');
  const [questionData, setQuestionData] = useState([]);
  const [mentorTopics, setMentorTopics] = useState([]);
  const [menteeTopics, setMenteeTopics] = useState([]);
  const userProfileEntity = useAppSelector(state => state.userProfile.entity);
  const stateData = useAppSelector(state => state);
  const questionEntity = useAppSelector(state => state.question.entity);
  const mentorTopicEntity = useAppSelector(state => state.mentorTopic.entity);
  const menteeTopicEntity = useAppSelector(state => state.menteeTopic.entity);
  const account = useAppSelector(state => state.authentication.account);
  const loggedIn_id = account.id;
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const baseImageUrl = '/profile/get/image';
  const toggleModal = () => {
    setModal(!modal);
  };
  const [Mainloading, setmainLoading] = useState(false);

  const onSwitchChange = async value => {
    setLoading(true);
    let userType = value == true ? 'Mentee' : 'Mentor';
    value == true ? setModal(true) : '';
    await dispatch(updateEntityUserType([id, !value]));
    setProfileType(userType);
    setIsMentee(value);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };
  useEffect(() => {}, [stateData]);

  const getTabFromUrl = () => {
    const params = new URLSearchParams(location.search);
    return params.get('tab') || 'profile';
  };

  useEffect(() => {
    const tab = getTabFromUrl();
    setActiveTab(tab);
  }, [location.search]);

  // useEffect(() => {
  //   const tabData = location?.state as StateType | undefined;
  //   if (tabData) {
  //     const tabActive = tabData.tab;
  //     setActiveTab(tabActive);
  //   }
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      setmainLoading(true);
      await dispatch(getEntityProfileDetails(id));
      await dispatch(getEntityTotalPoints());
      await dispatch(getEntityMenteeQuestions(id));
      await dispatch(getEntityMenteeTopic(id));
      await dispatch(getEntityMentorTopic(id));
      await dispatch(getUserMentorMenteeCount());
      setmainLoading(false);
    };

    fetchData();
  }, [modal, profileType, id]);
  useEffect(() => {
    const isMentee = userProfileEntity[0]?.isMentor ? false : true;
    setIsMentee(isMentee);
    let userType = userProfileEntity[0]?.isMentor ? 'Mentor' : 'Mentee';
    setProfileType(userType);
    Array.isArray(questionEntity) ? setQuestionData(questionEntity) : '';
  }, [userProfileEntity, questionEntity]);

  useEffect(() => {
    Array.isArray(mentorTopicEntity) ? setMentorTopics(mentorTopicEntity) : '';
    Array.isArray(menteeTopicEntity) ? setMenteeTopics(menteeTopicEntity) : '';
  }, [mentorTopicEntity, menteeTopicEntity]);

  const country = userProfileEntity[0]?.country;
  const countryName = country ? country : '';
  const stateCode = userProfileEntity[0]?.state;
  const countryCode = Object.keys(countriesList.countries).find(code => countriesList.countries[code].name === countryName);
  const statesOfCountry = getStatesOfCountry(countryCode);
  const stateInfo = statesOfCountry.find(state => state.isoCode === stateCode);
  const StateName = stateInfo?.name;
  const profileinfo = loggedIn_id === id ? 'loggedin' : 'guest';

  const redirectConnections = () => {
    navigate(`/user-profile/${loggedIn_id}?tab=connections`);
    setActiveTab('connections');
  };

  switch (profileinfo) {
    case 'guest':
      return (
        <>
          {Mainloading ? (
            <div className="token-loader-home">
              <div className="token-loader">
                <Spinner className="body-loader-icon"></Spinner>
              </div>
            </div>
          ) : (
            <div className="container fiveplus-small-screen guest-viewprofile">
              <Row className="top-back-btn">
                <Col md="12" className="d-flex justify-content-start">
                  <Button color="secondary" onClick={() => redirectConnections()}>
                    <img src="content/images/back-icon.svg" alt="icon" /> Back
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <div className="card view-user-profile users-card">
                    <h2 data-cy="userProfileDetailsHeading"></h2>

                    <ProfileHeader
                      user={userProfileEntity}
                      isMentee={isMentee}
                      onSwitchChange={onSwitchChange}
                      showSwitch={false}
                      showActions={false}
                      baseImageUrl={baseImageUrl}
                    />

                    <dl className="jh-entity-details">
                      <ProfileBasicInfo userProfileEntity={userProfileEntity} />
                      <ProfileAddress country={countryName} state={StateName} userProfileEntity={userProfileEntity} />

                      {profileType === 'Mentor' && (
                        <>
                          <Row className="pb-3 pt-3">
                            <ProfileTopics topics={mentorTopics} title="Topics" profileType={'Mentor'} />
                          </Row>
                        </>
                      )}

                      {profileType === 'Mentee' && (
                        <>
                          <ProfileTopics topics={menteeTopics} title="Topics" profileType={'Mentee'} />
                          {questionData.length != 0 ? (
                            <ProfileQuestions questions={questionData} />
                          ) : (
                            <Modal className="question-pop" isOpen={modal} toggle={toggleModal} backdrop="static" keyboard={false}>
                              <ModalHeader>My Five Questions to mentors ?</ModalHeader>
                              <ModalBody>
                                <MenteeQuesions popup={setModal} />
                              </ModalBody>
                            </Modal>
                          )}
                        </>
                      )}

                      <hr></hr>
                    </dl>
                    <ProfileStats mentors={userProfileEntity?.mentors_count} mentees={userProfileEntity?.mentees_count} />
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </>
      );
    default:
      return (
        <>
          <div className="container">
            <Tabs
              tab1Content={<Connections />}
              tab2Content={
                Mainloading ? (
                  <div className="token-loader">
                    <Spinner className="body-loader-icon"></Spinner>
                  </div>
                ) : (
                  <Row>
                    <Col md="12">
                      <div className="card view-user-profile users-card">
                        <h2 data-cy="userProfileDetailsHeading">
                          <div className="">My Profile </div>
                        </h2>

                        <ProfileHeader
                          user={userProfileEntity}
                          isMentee={isMentee}
                          onSwitchChange={onSwitchChange}
                          showSwitch={true}
                          showActions={true}
                          baseImageUrl={baseImageUrl}
                        />

                        <dl className="jh-entity-details">
                          <ProfileBasicInfo userProfileEntity={userProfileEntity} />
                          <ProfileAddress country={countryName} state={StateName} userProfileEntity={userProfileEntity} />

                          {profileType === 'Mentor' && (
                            <Row className="pb-3 pt-3">
                              <ProfileTopics topics={mentorTopics} title="Topics" profileType={'Mentor'} />
                            </Row>
                          )}

                          {profileType === 'Mentee' && (
                            <div id="topic-ques" className="topic-checkbox">
                              <ProfileTopics topics={menteeTopics} title="Topics" profileType={'Mentee'} />
                              {questionData.length != 0 ? (
                                <ProfileQuestions questions={questionData} />
                              ) : (
                                <Modal className="question-pop" isOpen={modal} toggle={toggleModal} backdrop="static" keyboard={false}>
                                  <ModalHeader>My Five Questions to mentors ?</ModalHeader>
                                  <ModalBody>
                                    <MenteeQuesions popup={setModal} />
                                  </ModalBody>
                                </Modal>
                              )}
                            </div>
                          )}

                          <hr></hr>
                        </dl>
                        <h3 className="pt-3 pb-3">My Points</h3>
                        <TotalPoints />
                        <ProfileStats mentors={userProfileEntity?.mentors_count} mentees={userProfileEntity?.mentees_count} />
                      </div>
                    </Col>
                    {loading ? (
                      <div className="loader_custom">
                        <Spinner>Loading...</Spinner>
                      </div>
                    ) : (
                      ''
                    )}
                  </Row>
                )
              }
              tab3Content={<Meetings />}
              tab4Content={<InspirationPage />}
              tab5Content={<ManagePoints />}
              tab6Content={<Interviews />}
              tab7Content={<Introvideo />}
              tab8Content={<HousingPage />}
              tab9Content={<GoodGovernancePage />}
              currentActiveTab={activeTab}
            />
          </div>
        </>
      );
  }
};

export default UserProfileDetail;
